module.exports = __webpack_public_path__ + "assets/9089c41d3f0a0cb111b6d1c96b6d504f.png";